'use client'

import { reporter } from '@/lib/reporter'
reporter.init()

import { Suspense, useEffect } from 'react'
import { Slide, ToastContainer } from 'react-toastify'

import { AuthModal } from '@/components/Auth/AuthModal'
import { SuperTokensInit } from '@/components/Auth/SuperTokensInit'
import BrowserCheck from '@/components/BrowserCheck'
import MetaPixel from '@/components/MetaPixel'
import PricingModal from '@/components/Pricing/PricingModal'
import { PostHogProvider } from '@/context/PosthogProvider'
import { monitorFPS, monitorRAM } from '@/lib/performance'
import './globals.css'
import StoreProvider from './StoreProvider'

export default function RootLayout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    Promise.allSettled([monitorFPS(), monitorRAM()]).then(([fpsR, heapSizeR]) => {
      if (fpsR.status === 'fulfilled') {
        const fps = fpsR.value
        console.log(`FPS: ${fps.toFixed(2)}`)
      }
      if (heapSizeR.status === 'fulfilled') {
        const { usedJSHeapSize, totalJSHeapSize } = heapSizeR.value
        console.log(`RAM: ${usedJSHeapSize.toFixed(2)}/${totalJSHeapSize.toFixed(2)}MB`)
      }
    })
  }, [])

  return (
    <html lang="en">
      <head>
        <Suspense>
          <MetaPixel />
        </Suspense>
      </head>
      <SuperTokensInit>
        <StoreProvider>
          <PostHogProvider>
            <body className="flex h-screen bg-black">
              <BrowserCheck />
              {children}

              <AuthModal />
              <PricingModal />

              <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                limit={3}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
                transition={Slide}
              />
            </body>
          </PostHogProvider>
        </StoreProvider>
      </SuperTokensInit>
    </html>
  )
}
